export default __webpack_public_path__ + "static/telemedicine-bf55758714a084aa2dd1940b0652d466.png";